import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import TablePagination from '@mui/material/TablePagination'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

import { useEffect, useState } from "react";
import axios from "axios";
import { ipUrl } from "../../Config/url";

const UnauthorizedLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await axios.get(`${ipUrl}/api/logs/unauthorized-access`, {
          params: { page: page + 1, limit: rowsPerPage },
          withCredentials: true,
        });
        setLogs(res.data.logs);
        setTotal(res.data.total);
      } catch (err) {
        console.error("Failed to fetch logs", err);
      } finally {
        setLoading(false);
      }
    };

    fetchLogs();
  }, [page]);

  const handlePageChange = (_e: unknown, newPage: number) => {
    setPage(newPage);
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Unauthorized Access Logs
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Card>
          <CardContent>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>User</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Path</TableCell>
                  <TableCell>Attempted At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logs.map((log: any) => (
                  <TableRow key={log._id}>
                    <TableCell>
                      {log.name || log.userId?.name || "Unknown"}
                    </TableCell>
                    <TableCell>{log.userType}</TableCell>
                    <TableCell>{log.path}</TableCell>
                    <TableCell>
                      {new Date(log.attemptedAt).toLocaleString()}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={total}
              page={page}
              onPageChange={handlePageChange}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[]}
            />
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default UnauthorizedLogs;